import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  root: {
    marginTop: 20,
  },
  diseaseTag: {
    marginBottom: 3,
  },
  drugDescrioption: {
    marginTop: 10,
  },
});

export default useStyles;